import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  getDocs,
} from 'firebase/firestore';
import moment from 'moment-timezone';
import { aggregateReport } from './analytics/aggregate';

// Reads completed orders straight from Firestore (instead of the MongoDB-backed
// `order-getOrderReport` cloud function) and aggregates them client-side.
// Reuses the deployed (storeId, status, closedAt) composite index. The callback
// receives the report wrapped in a single-element array to match the previous
// contract (Analytics does `setData(data[0])`).
const getReportData = async (
  storeId: string,
  startDate: string,
  endDate: string,
  locationId?: string,
  isDefaultLocation?: boolean,
  cb?: any,
) => {
  const start: number = moment(startDate).unix() * 1000;
  const end: number = moment(endDate).unix() * 1000;

  try {
    const db = getFirestore();
    const snapshot = await getDocs(
      query(
        collection(db, 'orders'),
        where('storeId', '==', storeId),
        where('status', '==', 'completed'),
        where('closedAt', '>=', start),
        where('closedAt', '<=', end),
        orderBy('closedAt', 'desc'),
      ),
    );

    let orders = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...(doc.data() as any),
    }));

    // The old function filtered by location server-side; do it here since we
    // already have all the orders in memory. Default location also matches
    // orders with no locationId (legacy / pre-locations data).
    if (locationId) {
      orders = orders.filter((order) =>
        isDefaultLocation
          ? order.locationId === locationId || order.locationId == null
          : order.locationId === locationId,
      );
    }

    cb?.([aggregateReport(orders)]);
  } catch (e) {
    console.error('Failed to load report data', e);
    cb?.([]);
  }
};

export default getReportData;
